export const BOOKING_DETAILS_MODAL = 'bookingItem';
